module.exports = __webpack_public_path__ + "fonts/ArialMT.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/ArialMT.ttf
// module id = 1081
// module chunks = 0